<template>
  <div>
    <el-table highlight-current-row :data="myOrder" stripe border style="font-size: 14px">
      <el-table-column prop="course_name" label="课程名称">
      </el-table-column>
      <el-table-column prop="orderId" label="订单编号">
      </el-table-column>
      <el-table-column prop="payTime" label="下单时间">
      </el-table-column>
      <el-table-column prop="course_price" label="课程价格">
      </el-table-column>
      <el-table-column prop="final_fee" label="实际支付">
      </el-table-column>
      <el-table-column prop="payType" label="支付方式">
        <template slot-scope="scope">
          <span v-show="scope.row.payType == 1">微信支付</span>
          <span v-show="scope.row.payType == 2">支付宝支付</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import urls from '../../common/js/urls.js'

export default {
  name: 'personal-order-list',
  data() {
    return {
      myOrder: []
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  watch: {
    'user.user_id': {
      handler: function (val, oldVal) {
        this.getOrderList();
      },
      deep: true
    }
  },
  mounted() {
    this.getOrderList();
  },
  methods: {
    getOrderList() {
      var _this = this;
      this.axios.get(urls.get_orders + "?userid=" + _this.user.user_id + "&pageNum=1&pageSize=999").then(function (res) {
        _this.myOrder = res.data.myOrderList;
      })
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
}

.track-list {
  padding-left: 5px;
  position: relative;
}

.track-list li {
  position: relative;
  padding: 9px 0 0 25px;
  line-height: 18px;
  border-left: 1px solid #d9d9d9;
  color: #999;
}

.track-list li.first {
  color: red;
  padding-top: 0;
  border-left-color: #fff;
}

.track-list li .node-icon {
  position: absolute;
  left: -6px;
  top: 50%;
  width: 11px;
  height: 11px;
  background: url(../../common/imgs/order-icons.png) -21px -72px no-repeat;
}

.track-list li.first .node-icon {
  background-position: 0 -72px;
}

.track-list li .time {
  margin-right: 20px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
}

.track-list li .txt {
  max-width: 600px;
  position: relative;
  top: 4px;
  display: inline-block;
  vertical-align: middle;
}

.track-list li.first .time {
  margin-right: 20px;
}

.track-list li.first .txt {
  max-width: 600px;
}

.track-list h4 {
  margin-left: 40px;
}

.grspan {
  color: #999;
}

</style>



// WEBPACK FOOTER //
// src/components/Personal/PersonalOrderList.vue